var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConversionCost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 7.68,
    fill: "#B49FF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20186_136083)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3334 16.0013C24.3334 20.6036 20.6024 24.3346 16.0001 24.3346C11.3977 24.3346 7.66675 20.6036 7.66675 16.0013C7.66675 11.3989 11.3977 7.66797 16.0001 7.66797C20.6024 7.66797 24.3334 11.3989 24.3334 16.0013Z",
    stroke: "white",
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2585 14.3846C18.1759 13.749 17.4462 12.7222 16.134 12.7221C14.6094 12.7221 13.9678 13.5665 13.8376 13.9887C13.6346 14.5535 13.6752 15.7146 15.4623 15.8412C17.6962 15.9995 18.5911 16.2632 18.4773 17.6303C18.3634 18.9974 17.1181 19.2928 16.134 19.2611C15.1499 19.2295 13.5397 18.7774 13.4772 17.5614M15.9779 11.832V12.7252M15.9779 19.2529V20.1653",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20186_136083"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversionCost);
export default __webpack_public_path__ + "static/media/conversionCost.c1ce322ad2056ab6a76940745ee26ee8.svg";
export { ForwardRef as ReactComponent };